/**
 * UI strings of the lens card (not the persona narrative, which lives in
 * ../personas.ts). Every visible string and accessible name exists in RU and
 * EN; EN avoids decorative dashes.
 */

import type { Bilingual } from '../types';

export const LENS_COPY = {
  lens: { ru: 'Линза', en: 'Lens' },
  scene: { ru: 'Сцена', en: 'Scene' },
  of: { ru: 'из', en: 'of' },
  collapse: { ru: 'Свернуть линзу', en: 'Collapse lens' },
  restore: { ru: 'Развернуть линзу', en: 'Expand lens' },
  showFull: { ru: 'Показать линзу целиком', en: 'Show the full lens' },
  tryPrefix: { ru: 'Попробуйте', en: 'Try this' },
  questions: { ru: 'Вопросы для ассистента', en: 'Questions for the assistant' },
  askPrefix: { ru: 'Спросить', en: 'Ask' },
} as const satisfies Record<string, Bilingual>;

export type LensCopyKey = keyof typeof LENS_COPY;
